import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import globalReducer from './slices/globalSlice';
import websocketReducer from './slices/websocketSlice';

import { initialDataMiddleware } from './middleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    global: globalReducer,
    websocket: websocketReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(initialDataMiddleware),
});

export default store;
